var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var ready = require('./ready');

module.exports = function (socket, options) {
  options = options || {};
  options.closeOnEnd = options.closeOnEnd !== false;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _iterator.next();

            case 6:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 22;
                break;
              }

              data = _step.value;
              _context.prev = 8;
              _context.next = 11;
              return ready(socket);

            case 11:
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](8);

              if (!(_context.t0.message === 'socket closed')) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("break", 22);

            case 17:
              throw _context.t0;

            case 18:
              socket.send(data);

            case 19:
              _iteratorAbruptCompletion = false;
              _context.next = 4;
              break;

            case 22:
              _context.next = 28;
              break;

            case 24:
              _context.prev = 24;
              _context.t1 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 28:
              _context.prev = 28;
              _context.prev = 29;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 33;
                break;
              }

              _context.next = 33;
              return _iterator.return();

            case 33:
              _context.prev = 33;

              if (!_didIteratorError) {
                _context.next = 36;
                break;
              }

              throw _iteratorError;

            case 36:
              return _context.finish(33);

            case 37:
              return _context.finish(28);

            case 38:
              if (!(options.closeOnEnd && socket.readyState <= 1)) {
                _context.next = 40;
                break;
              }

              return _context.abrupt("return", new Promise(function (resolve, reject) {
                socket.addEventListener('close', function (event) {
                  if (event.wasClean || event.code === 1006) {
                    resolve();
                  } else {
                    var err = Object.assign(new Error('ws error'), {
                      event: event
                    });
                    reject(err);
                  }
                });
                setTimeout(function () {
                  return socket.close();
                });
              }));

            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 24, 28, 38], [8, 13], [29,, 33, 37]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};